var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";
import AuthenticatedFrameResolver from "./user-interface/layout/authenticated-frame/AuthenticatedFrameResolver";
import { initializeTranslations } from "./user-interface/_common/i18n/i18n";
import AuthenticatedFrame from "./user-interface/layout/authenticated-frame/AuthenticatedFrame";
import { Provider } from "react-redux";
import { globalStore } from "@/v2/application/_common/global-store/store";
const router = createBrowserRouter([
    {
        path: "/v2",
        element: _jsx(AuthenticatedFrameResolver, {}),
        children: [
            {
                path: "",
                element: _jsx(AuthenticatedFrame, {}),
                children: [
                    {
                        path: "dashboard",
                        lazy() {
                            return __awaiter(this, void 0, void 0, function* () {
                                const { DashboardFeature } = yield import("./user-interface/dashboard/dashboard.routes");
                                return DashboardFeature;
                            });
                        },
                    },
                ],
            },
        ],
    },
]);
export default function V2Root() {
    initializeTranslations();
    return (_jsxs(_Fragment, { children: [_jsx(ToastContainer, { position: "bottom-center", autoClose: 5000, hideProgressBar: false, newestOnTop: true, closeOnClick: true, rtl: false, pauseOnFocusLoss: true, draggable: true, pauseOnHover: true, transition: Slide, stacked: true }), _jsx(Provider, { store: globalStore, children: _jsx(RouterProvider, { router: router }) })] }));
}
